export default {
  path: '/org',
  name: 'Org',
  redirect: '/org/list',
  component: () => import('@/components/layout'),
  meta: { requiresAuth: true },
  children: [
    {
      path: 'list',
      component: () => import('@/views/org'),
      meta: { requiresAuth: true }
    },
    {
      path: 'info',
      component: () => import('@/views/org/info'),
      meta: { requiresAuth: true }
    },
    {
      path: 'setting',
      component: () => import('@/views/org/setting'),
      meta: { requiresAuth: true }
    }
  ]
}
